import api from './api';
import createModel from 'helpers/model';
import statsHelper from '../statsHelper';

export default createModel({
  isLoading: false,
  error: null,
  data: null,
}, {
  ...statsHelper((employeeId, from, to) => {
    // API expects keys: from_dt, to_dt
    return api.post('individual-details', { employee_id: employeeId, from_dt: from, to_dt: to });
  }),
});